import { useState, useEffect, useCallback } from 'react';

const useColumnFilters = (columnFilters = []) => {
  const [filterOptions, setFilterOptions] = useState({});
  const [loadingFilters, setLoadingFilters] = useState({});

  const fetchFilterOptions = useCallback(async (filterConfig) => {
    if (!filterConfig.loadOptions) return;

    const { key, loadOptions, optionsTransform } = filterConfig;

    setLoadingFilters((prev) => ({ ...prev, [key]: true }));

    try {
      const response = await loadOptions();
      const responseData = response?.data ?? response;

      const options = optionsTransform
        ? optionsTransform(responseData)
        : responseData;

      setFilterOptions((prev) => ({ ...prev, [key]: options }));
    } catch (error) {
      console.error(error);
      setFilterOptions((prev) => ({ ...prev, [key]: [] }));
    } finally {
      setLoadingFilters((prev) => ({ ...prev, [key]: false }));
    }
  }, []);

  useEffect(() => {
    columnFilters.forEach((filterConfig) => {
      if (filterConfig.loadOptions) {
        fetchFilterOptions(filterConfig);
      } else if (filterConfig.options) {
        setFilterOptions((prev) => ({
          ...prev,
          [filterConfig.key]: filterConfig.options,
        }));
      }
    });
  }, [columnFilters, fetchFilterOptions]);

  const getFilterOptions = useCallback(
    (columnKey) => {
      return filterOptions[columnKey] || [];
    },
    [filterOptions],
  );

  const isFilterLoading = useCallback(
    (columnKey) => {
      return loadingFilters[columnKey] || false;
    },
    [loadingFilters],
  );

  return {
    getFilterOptions,
    isFilterLoading,
  };
};

export default useColumnFilters;
